import React, { useEffect, useState } from "react";
import styles from "./Style.module.css";
import { BtnPrimary } from "../Buttons/BtnPrimary";
import { useVoucherContext } from "../../Context/Voucher/VoucherContext";
import { PriceBreakdownPopup } from "../Popup/PriceBreakdownPopup/PriceBreakdownPopup";

function VoucherCart({
  btnLabel = "Add",
  btnClick,
  isCartActive = false,
  disabled = false,
  displayTotal = 0,
  displayCount = 0,
}) {
  const { selectedVouchers } = useVoucherContext();
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);

  const handleShowPriceBreakDown = () => {
    setShowPriceBreakdown(true);
  };

  const handleClosePriceBreakdown = () => {
    setShowPriceBreakdown(false);
  };

  useEffect(() => {
    const body = document.body;
    body.classList.remove("overlay", "half", "overlay-index", "overflow-hidden");
    if (showPriceBreakdown) {
      body.classList.add("overlay", "overflow-hidden");
    }
  }, [showPriceBreakdown]);

  if (!isCartActive) return null;

  return (
    <>
      <div data-snackbar-footer="true" className={`${styles.cartCard} ${styles.active}`}>
        <div className={`${styles.cartCardContainer} container space-x`}>
          <div className={styles.cartCardLeft}>
            <h5>
              S$
              <span>{Number(displayTotal).toFixed(2)}</span>
            </h5>
            <h6
              className={`${styles.cartCardCount} btn`}
              onClick={handleShowPriceBreakDown}
            >
              <span>{displayCount}</span>{" "}
              {displayCount !== 1 ? "Vouchers" : "Voucher"}
            </h6>
          </div>
          <div className={styles.cartCardRight}>
            <BtnPrimary label={btnLabel} handleClick={btnClick} disabled={disabled} />
          </div>
        </div>
      </div>
      <PriceBreakdownPopup
        displayTotal={displayTotal}
        selectedVouchers={selectedVouchers}
        active={showPriceBreakdown}
        onClose={handleClosePriceBreakdown}
        isVoucher={true}
      />
    </>
  );
}

export { VoucherCart };
export default VoucherCart;
